import React, { useMemo, useRef, useState } from "react";

import "./spread-overview-item.css";
import { SpreadOverviewThumb } from "./spread-overview-thumb";
import { useIntersectionObserver } from "../../hooks/useIntersectionObserver";
import { useSpreadRenderer } from "../../hooks/useSpreadRenderer";

const maxThumbSize = 750;

/** Contains one spread thumb with allowed buttons */
export const SpreadOverviewThumbContainer = ({
	spread,
	isSelected,
	onClick,
}: {
	spread: eXpress.core.Spread;
	isSelected: boolean;
	onClick?: () => void;
}) => {
	const thumbRef = useRef<HTMLDivElement>(null);
	const [isInView, setIsInView] = useState<boolean>(false);

	const imageSize = useMemo(
		() =>
			eXpress.math
				.vector(spread.width, spread.height)
				.fit(eXpress.math.vector(maxThumbSize))
				.toVector(),
		[spread],
	);

	const { isLoading, isError } = useSpreadRenderer({
		// Should we keep spread when it goes out of view to keep the rendered spread in the DOM?
		spread: isInView ? spread : undefined,
		imageSize,
		containerRef: thumbRef,
		canvasPreviewModeEnabled: false,
	});

	useIntersectionObserver(thumbRef, (entry) => {
		setIsInView(entry.isIntersecting);
	});

	return (
		<SpreadOverviewThumb
			spread={spread}
			isLoading={isLoading}
			isError={isError}
			isSelected={isSelected}
			onClick={onClick}
			ref={thumbRef}
		/>
	);
};
